/* eslint-disable */ 
import { NewsCategoryTypes } from "../types";

export const NewsCategory: NewsCategoryTypes = {
    tesla: 'tesla',
    apple: 'apple',
    meta: 'meta',
    google: 'google',
    twitter: 'twitter',
    netflix: 'netflix',
  };


  
  export const NEWS_FEED: string  = 'News Feed';
  export const EN : string = 'En';
  export const THEME: string  = 'Theme';
  export const AR: string  = 'Ar';
  export const NO_DATA_FOUND: string  = 'No Data Found';
  export const LANGUAGE: string  = 'Language';
  export const GET_NEWS_FEED: string  = 'GET_NEWS_FEED';
  export const SOMETHING_WENT_WRONG: string  = 'Something went wrong';
  export const PUBLISHED_AT: string  = 'publishedAt';
  export const ERROR_OCCURED_WHILE_OPENING: string = 'Error occured while opening URL';

  
  